var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIshaClientEwigo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_638_1231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_638_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8755 33.3491H73.394V65.769H80.8755V33.3491Z",
    fill: "url(#paint0_linear_638_1231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72579 40.0749V46.1961H23.8953V52.922H9.72579V59.0054H26.4647V65.7312H3V33.3491H26.4647V40.0749H9.72579Z",
    fill: "url(#paint1_linear_638_1231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.745 49.5591C139.745 54.5089 135.74 58.5142 130.79 58.5142C125.84 58.5142 121.835 54.5089 121.835 49.5591C121.835 44.6092 125.84 40.6039 130.79 40.6039C135.74 40.6039 139.745 44.6092 139.745 49.5591ZM130.79 33.3491C121.835 33.3491 114.58 40.6039 114.58 49.5591C114.58 58.5142 121.835 65.769 130.79 65.769C139.745 65.769 147 58.5142 147 49.5591C147 40.6039 139.745 33.3491 130.79 33.3491Z",
    fill: "url(#paint2_linear_638_1231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.049 47.1783V59.6474C110.348 61.7634 108.157 63.4638 105.587 64.484C103.698 65.2775 101.582 65.7309 99.3906 65.7309C90.4355 65.7309 83.1807 58.4761 83.1807 49.521C83.1807 40.5658 90.4355 33.311 99.3906 33.311C104 33.311 108.157 35.2381 111.104 38.3365C110.122 39.5078 108.232 41.8883 106.872 43.6642C105.134 41.4349 102.413 40.0368 99.3906 40.0368C94.1384 40.0368 89.9065 44.2688 89.9065 49.521C89.9065 54.7731 94.1384 59.0051 99.3906 59.0051C101.771 59.0051 103.925 58.136 105.587 56.7002V53.6018H98.6349V47.1405H112.049V47.1783Z",
    fill: "url(#paint3_linear_638_1231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1851 33.3491L60.2072 65.7312H52.3478L50.2696 60.1767L48.2292 65.7312H45.5842L46.9067 62.1794L48.9471 56.5871L52.8768 45.9694L57.5622 33.3491H60.2072L54.1993 49.5591L56.2775 55.1135L64.3258 33.3491H72.1851Z",
    fill: "url(#paint4_linear_638_1231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9172 33.3491L51.5921 42.3798V42.4176L47.6246 53.0353L45.5842 58.5898L42.9392 65.7312H40.3698L39.0473 62.1794L37.7248 58.5898L28.3918 33.3491H36.2512L41.6545 47.9721L42.977 51.5617L44.2995 55.1135L46.3399 49.5591L45.0174 45.9694L43.7327 42.4176V42.3798L40.3698 33.3491H48.2292L48.9849 35.314V35.3518L50.2696 38.9036L52.3478 33.3491H54.9172Z",
    fill: "url(#paint5_linear_638_1231)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_638_1231",
    x1: 77.1241,
    y1: 33.3349,
    x2: 77.1241,
    y2: 65.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_638_1231",
    x1: 14.7322,
    y1: 33.3349,
    x2: 14.7322,
    y2: 65.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_638_1231",
    x1: 130.804,
    y1: 33.3349,
    x2: 130.804,
    y2: 65.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_638_1231",
    x1: 97.6299,
    y1: 33.3346,
    x2: 97.6299,
    y2: 65.7489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_638_1231",
    x1: 58.8777,
    y1: 33.3349,
    x2: 58.8777,
    y2: 65.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_638_1231",
    x1: 41.6524,
    y1: 33.3349,
    x2: 41.6524,
    y2: 65.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6B28"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIshaClientEwigo);
export default __webpack_public_path__ + "static/media/isha-client-ewigo.b8af282a95e929bfabac17e5e7f3ce2f.svg";
export { ForwardRef as ReactComponent };